import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// 🔐 자동 로그인 OFF (2026-07-11) — 로그인 화면에서 '자동 로그인' 해제(tpt-autologin='0') 시,
// 앱/브라우저를 새로 시작한 세션이면 저장된 인증을 부팅 시점에 제거해 로그인 화면으로.
// sessionStorage 마커로 같은 세션 내 새로고침(F5)은 유지. persist 가 읽기 전에 실행돼야 하므로 모듈 최상단.
// ⚠️ 팝아웃 창(/calendar,/ai)·알림 창은 별도 sessionStorage 라 제외 — 메인 창 인증을 지우면 안 됨.
try {
	if (typeof window !== 'undefined') {
		const p = window.location.pathname;
		const isPopout = p === '/calendar' || p === '/ai' || p.includes('notify');
		if (!isPopout && localStorage.getItem('tpt-autologin') === '0' && !sessionStorage.getItem('tpt-sess-live')) {
			localStorage.removeItem('tpt-auth');
		}
		sessionStorage.setItem('tpt-sess-live', '1');
	}
} catch { /* private mode */ }

interface AuthState {
	authToken: string | null;
	userId: string | null;
	username: string | null;
	displayName: string | null;
	roles: string[];
	// 준회원 온보딩(이름 입력) 완료 여부. 정회원/관리자는 항상 true(게이트 미적용). 신규 준회원만 false.
	nameConfirmed: boolean;
	setAuth: (token: string, userId: string, username: string, displayName?: string, roles?: string[], nameConfirmed?: boolean) => void;
	setRoles: (roles: string[]) => void;
	setNameConfirmed: (v: boolean) => void;
	clear: () => void;
}

export const useAuthStore = create<AuthState>()(
	persist(
		(set) => ({
			authToken: null,
			userId: null,
			username: null,
			displayName: null,
			roles: [],
			nameConfirmed: true,
			setAuth: (token, userId, username, displayName, roles, nameConfirmed) =>
				set({ authToken: token, userId, username, displayName: displayName ?? username, roles: roles ?? [], nameConfirmed: nameConfirmed ?? true }),
			setRoles: (roles) => set({ roles: roles ?? [] }),
			setNameConfirmed: (v) => set({ nameConfirmed: v }),
			clear: () => set({ authToken: null, userId: null, username: null, displayName: null, roles: [], nameConfirmed: true }),
		}),
		{ name: 'tpt-auth' },
	),
);
